export default __webpack_public_path__ + "static/media/miguel-lopes-13.e278580a.jpg";